import { ShieldCheck, FileCheck2, Lock } from "lucide-react";

export function SecurityBadge({ className = "" }) {
    return (
        <div
            className={`fs-pill gap-3 px-3.5 py-1.5 rounded-full border border-white/[0.08] bg-white/[0.025] text-[11px] font-medium text-white/75 ${className}`}
            data-testid="security-badge"
        >
            <span className="inline-flex items-center gap-1.5">
                <ShieldCheck className="h-3.5 w-3.5 text-[#00BF0D]" />
                <span>Bank-grade</span>
            </span>
            <span className="text-white/15">·</span>
            <span className="inline-flex items-center gap-1.5">
                <FileCheck2 className="h-3.5 w-3.5 text-[#00BF0D]/85" />
                <span>SOC 2 Ready</span>
            </span>
            <span className="text-white/15">·</span>
            <span className="inline-flex items-center gap-1.5">
                <Lock className="h-3 w-3 text-white/55" />
                <span>Audit-Ready Ledger</span>
            </span>
        </div>
    );
}
